import React from 'react';
import { Flex } from '@components';
import {Form, Input, Button, Upload, Icon, message, Spin, Radio, Modal, DatePicker} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import {createUuid, getLoginUser} from '@utils/NHCore';
import NHFetch from "@utils/NHFetch";
const Dragger = Upload.Dragger;
import CommonTip from "@pages/SelfHelp/common";
import NextButton from '@pages/SelfHelp/common/nextIndex';
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import NHFormItem from "@components/common/NHFormItem";
import View from "@pages/SelfHelp/accomCommJsnm/view";
import NHUpload from '@components/common/NHUpload'
import NHSelect from "@components/common/NHSelect";
import NHCascader from "@components/common/NHCascader";
import moment from "moment/moment";
import './index.css'
import {NHConfirm} from "@components/common/NHModal";

const dateFormat = 'YYYY-MM-DD ';
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { confirm } = Modal
const formItemLayout = {
    labelCol: { span: 12 },  // 增加标签宽度
    wrapperCol: { span: 10 } // 减少控件宽度
};
const formItemLayoutJx = {
    labelCol: { span: 7 },
    wrapperCol: { span: 15 }
};
const basePath = '/jsnm/accomComm';

@Form.create()
export default class AccomCommJsnm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz:'GD006_9',
            hjmc:'',

            nextUrl:'',
            search:'',
            cfdStr:'',
            jyjlData: [],
            kssj:'',
            jssj:'',
            shzt:'',
            operable:true,//是否显示环节
            nonOperationalData:{},//不可操作的数据
            zsqkList: [{'LABEL': '住宿', 'VALUE': '1'}, {'LABEL': '走读', 'VALUE': '0'}], // 住宿情况列表
            zsqk: '', // 住宿情况, '1':住宿, '0': 走读
            data: {}, // 住宿情况详细数据
            editable: true, // 是否可编辑
            saveLoading:false,
            loading:false,
            identityCardFrontUrl: '',   //身份证正面
            identityCardOppositeUrl: '',   //身份证反面
            identityCardFrontUrlHz: '',   //户口本户主
            identityCardOppositeUrlXs: '',   //户口本学生自己
            identityCardFrontUrlJz: '',   //家长身份证正面
            identityCardOppositeUrlJz: '',   //家长身份证反面
            identityCardFrontUrlTwo: '',
            identityCardFrontUrlZfxy: '',

            identityCardFrontOriginUrl:'',    //身份证正面源数据
            identityCardOppositeOriginUrl:'',   //身份证反面源数据
            uploadImg: false,
            previewVisible: false,

            mbid: ''
        };
    }

    componentDidMount(){
       this.getData();
       this.queryQztjAndYlhj((operable) => {
            if (operable) {
                this.updateZzbdBlzt();
            }
        });
        this.getMbid();
    }

    getMbid = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", {csbz: 'YXXT_JSNM_ZSZDDJMB'})
        .then(res => {
            if (res && res.data) {
                NHFetch('api/zhxg-yxwz/dynamic/'+res.data+'/getDetailed','GET').then(res =>{
                    if (res && res.data){
                        this.setState({
                            mbid: res.data[0].uuid
                        });
                    }
                })
            }
        })
    }

    //迎新现场已办理时迎新网站自动办理
    updateZzbdBlzt = () =>{
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch('/zzbd/updateZzbdBlzt', 'GET',{zzbdhjid:zzbdhjid,hjdm: this.state.mkbz}).then(res => {
            if(res.data){
                this.reloadMenu();
            }
        })
}

    // 获取住宿走读填写数据
    getData = (flag) => {
        let zzbdhjid = this.getQueryString('pkid');
        let xsid = getLoginUser()?getLoginUser().userId:'';
        NHFetch(basePath + `/get/${xsid}`, 'GET').then(res => {
            if(flag=="edit"){
                this.setState({
                    editable:true
                })
                return;
            }
            NHFetch(basePath + '/getShzt','GET',{xsid: xsid,zzbdhjid:zzbdhjid}).then(res =>{
                if(res){
                    this.setState({
                        shzt:res.data
                    })
                }
            })
            NHFetch('/zzbdCommon/getBlztByHjdm','GET',{xsid: xsid, hjdm: this.state.mkbz}).then(res =>{
                if(res){
                    if(res.data == '1'){
                        this.setState({
                            editable: false
                        })
                    }
                }
            })

            if (res && res.data) {
                this.setState({
                    data: res.data,
                    kssj: res.data.ZDKSSJ,
                    jssj: res.data.ZDJSSJ,
                    zsqk: res.data.sfzs
                })
            } else {
                this.props.form.resetFields();
            }
        })
    }

    // 获取住宿走读填写数据
    getDataView = (flag) => {
        let zzbdhjid = this.getQueryString('pkid');
        let xsid = getLoginUser()?getLoginUser().userId:'';
        NHFetch(basePath + `/get/${xsid}`, 'GET').then(res => {
            if(flag=="edit"){
                this.setState({
                    editable:true,
                    shzt: 4
                })
            }

            if (res && res.data) {
                this.setState({
                    data: res.data,
                    kssj: res.data.ZDKSSJ,
                    jssj: res.data.ZDJSSJ,
                    zsqk: res.data.SFZS
                })
            } else {
                this.props.form.resetFields();
            }
        })
    }


    //查询前置条件和依赖环节
    queryQztjAndYlhj=(callback)=>{
        let xsid = getLoginUser()?getLoginUser().userId:'';
        if(!xsid){
            this.setState({
                nonOperationalData:{nologin:true},
                operable:false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid:xsid,zzbdhjid:zzbdhjid})
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({nonOperationalData:res.data});
                    if(kfsj && kfsj['YXSJ']!='1'){
                         this.setState({operable:false});
                    }

                    if(ylhj && ylhj.length>0){
                        this.setState({operable:false});
                    }

                    if(qzhj && qzhj.length>0){
                        this.setState({operable:false});
                    }
                    if (nohj) {
                        this.setState({ operable: false });
                    }
                    if (callback) {
                        callback(this.state.operable);
                    }
                    
                }
            });
    }

    getQueryString =(name)=> {
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[, ''])[1].replace(/\+/g, '%20')) || null
    }

    


   
    setMenuList=(menuList)=>{
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem,index)=>{
            if(elem.HJDM==bz){
                let hjmc = elem.HJMC;
                this.setState({hjmc:hjmc})
                nextCount = index+1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if(menu){
            let hjdm = menu.HJDM;
            if(hjdm.indexOf('GD')==0){
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl:gdUrl,
                    search:'pkid='+menu.PKID,
                })
            }else if(hjdm.indexOf('ZDY')==0){
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl:zdyUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm+'&lx='+menu.LX,
                })
            }else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        }else{
            this.setState({
                nextUrl:'',
                search:'',
            })
        }
    }

    //提交
    handleOk = e =>{
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if(err){
                this.setState({loading:false,saveLoading:false});
                return false;
            }
            const { zsqk,shzt } = this.state;
            if(this.state.zsqk === '0') { //走读
                confirm({
                    title: '提示',
                    content: '是否确定提交?',
                    okText: '确定',
                    cancelText: '取消',
                    okType: 'danger',
                    iconType: 'info-circle',
                    onOk: () => {
                        this.saveFile(values['fjid'],values['sfzgh'],values['sfzrx'],
                            values['jzsfzgh'],values['jzsfzrx'],values['hkbhz'],values['hkbxs'],values['aqxytwo'],values['zfxy'],
                            () => this.handleSubmit(values))
                    },          //,sfzgh,sfzrx,jzsfzgh,jzsfzrx,hkbhz,hkbxs,aqxytwo,zfxy,
                    onCancel() {

                    },
                });
            }else {//住宿
                this.handleSubmit(values)
            }

        })
        
    }

    handleSubmit = formData => {
        const { zsqk,shzt } = this.state;
        let xsid = getLoginUser().userId?getLoginUser().userId:"";
        if(!xsid){
            message.error("登录已过期，请重新登录！");
            return;
        }
        this.setState({loading:true,saveLoading:true}); 
        let zzbdhjid = this.getQueryString('pkid');
            
        let params = {};
        params.xsid = xsid || '';
        params.sfzs = zsqk || '';

        //params.khh = formData['khh'] || '';
        //params.yhzh = formData['yhzh'] || '';
        params.sjhm = formData['sjhm'] || '';
        //params.xn = formData['xn'] || '';
        if(this.state.zsqk === '0') {
        if(formData['jzdz']){
            params.jzdz =  formData['jzdz'][2] || formData['jzdz'][1] || formData['jzdz'][0] || ''
        }else{
            params.jzdz = '' || '';
        }
        if(params.jzdz === ''){
            message.error("请填写居住地址！！")
            this.setState({ loading: false,editable:false,saveLoading:false })
            return;
        }
        }
        params.jzdxxdz = formData['jzdxxdz'] || '';
        //params.sftf = formData['sftf'] || '';
        params.jzxm = formData['jzxm'] || '';
        params.jzdh = formData['jzdh'] || '';

        params.sfzgh = formData['sfzgh']|| '';
        params.sfzrx =  formData['sfzrx'] || '';
        params.jzsfzgh = formData['jzsfzgh'] || '';
        params.jzsfzrx =  formData['jzsfzrx'] || '';
        params.hkbhz =  formData['hkbhz'] || '';
        params.hkbxs = formData['hkbxs'] || '';
        params.aqxytwo =  formData['aqxytwo'] || '';
        params.zfxy =  formData['zfxy'] || '';

        params.zdkssj = this.state.kssj;
        params.zdjssj = this.state.jssj;
        if(this.state.zsqk === '0') {
        if( this.state.kssj === '' || this.state.jssj === ''){
            message.error("请填写时间！！")
            this.setState({ loading: false,editable:false,saveLoading:false })
            return;
        }
        }
        params.sqzdly = formData['sqzdly'];
        params.hjblFlag = true;
        params.zzbdhjid = zzbdhjid;
        params.pkid = formData['pkid'];
        params.fjid = formData['fjid'];
    
        NHFetch(`${basePath}/save`,"POST",params)
        .then(res => {
            if (res && res.data && res.code == 200) {
                message.success("住宿走读情况提交成功");
                this.getData();
                this.reloadMenu(); 
            } else {
                message.success("住宿走读情况提交失败，请重试。");
            }
            this.setState({ loading: false,editable:false,saveLoading:false })
        }).catch((res) => {
        this.setState({ loading: false,saveLoading:false })
        return res;
        });
    }

    saveFile = (fjzbid,sfzgh,sfzrx,jzsfzgh,jzsfzrx,hkbhz,hkbxs,aqxytwo,zfxy, callback) => {
        //保存附件主表id
        return NHFetch('api/zhxg-yxwz/dynamic/save', 'POST', [fjzbid,sfzgh,sfzrx,jzsfzgh,jzsfzrx,hkbhz,hkbxs,aqxytwo,zfxy]).then(res => {
          if (res && res.code === 200) {
            //保存成功，执行相应操作
            callback();
          } else {
            message.error('附件保存失败')
          }
        })
    }

    //重新加载菜单
    reloadMenu=()=>{
        this.refs.siderMenu.reloadMenuList()
    }

    handleDownload = async (fjid) => {
        if (!fjid) {
            message.error('未设置模板，请联系管理员设置模板');
            return;
        }

        window.open("zuul/docrepo/download/file?attachmentId=" + fjid);
    };

    onNHCascaderChange = (value, selectedOptions) => {
        let label = '';
        if (selectedOptions) {
            selectedOptions.forEach((i) => {
                label += i.label;
            });
        }
        this.setState({cfdStr: label});
    }

    handleDateChange = (value, index) => {
        // 创建状态数组的浅拷贝
        const jyjlData = [...this.state.jyjlData];

        // 确保索引位置存在对象
        if (!jyjlData[index]) {
            jyjlData[index] = {};
        }

        // 格式化日期
        const kssj = value[0] ? moment(value[0]).format(dateFormat) : undefined;
        const jssj = value[1] ? moment(value[1]).format(dateFormat) : undefined;

        // 更新数组元素
        jyjlData[index] = {
            ...jyjlData[index],
            kssj,
            jssj
        };

        // 更新状态
        this.setState({
            jyjlData,
            kssj,
            jssj
        });
    }

    // 获取学生头像
    getStudentPhotoBase64 = (type) => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (userId) {
            NHFetch('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', {xsid: userId, type: type})
                .then(res => {
                    if (res && res.code === 200&&res.data){
                        if (type === '70'){
                            this.setState({
                                identityCardOppositeUrl: `data:image/jpeg;base64,${res.data}`,
                                identityCardOppositeOriginUrl: `data:image/jpeg;base64,${res.data}`,
                            })
                        }

                        if (type === '71'){
                            this.setState({
                                identityCardFrontUrl: `data:image/jpeg;base64,${res.data}`,
                                identityCardFrontOriginUrl: `data:image/jpeg;base64,${res.data}`,
                            })
                        }

                    }
                });

        }
    };

    showPreview = url => {
        this.setState({
            previewImage: url,
            previewVisible: true,
        })
    };

    submitCheck =(flag) => {
        const submitCheck = this.props.submitCheck;
        if(typeof submitCheck ==="function"){
            submitCheck(flag);
        }
    }

    beforeUpload = (file) => {

        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJPG) {
            message.error("You can only upload JPG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        return isJPG && isLt2M;
    }

    render() {
        const {form} = this.props;
        const { getFieldDecorator } = this.props.form;
        const { data, hjmc, editable, zsqkList, zsqk, mkbz, mbid,shzt } = this.state;
       

        return (
            <div style={{position:'relative'}}>{this.state.operable?
                <div>
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                                ref={"siderMenu"}
                                setMenuList={this.setMenuList}
                                title="自助报到"
                                mkbz = {this.state.mkbz}
                          /*     active={4}*/
                                menuType='自助报到'/>
                    <Flex.Item className="page_con_r" styleName="">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <Hint/>
                            {editable &&( shzt === 0  || shzt === 4)  ?<Form>
                                <TitleTop title="登记信息" extra={false} />
                                <div className="p-sw">

                                    <div style={{display:'none'}}>
                                    <NHFormItem id={'pkid'} initialValue={data['pkid']} form={form}>
                                        <Input/>
                                    </NHFormItem>
                                    </div>

                                    <div className="form_item" style={{marginLeft: '7%'}}>
                                    <NHFormItem required={true} id={'sfzs'} initialValue={data['SFZS']} form={form}  formItemLayout = {formItemLayout} label="住宿情况">
                                        <Radio.Group onChange={(e) => this.setState({zsqk: e.target.value})} value={zsqk} style={{display:"flex",margin:"10px"}}>
                                            {
                                                zsqkList && zsqkList.map((item,index)=>{
                                                   return <Radio value={item.VALUE}>{item.LABEL}</Radio>
                                                })
                                            }
                                        </Radio.Group>
                                    </NHFormItem>
                                    </div>
                                    {zsqk=='0' && <div className="form_item" style={{marginLeft: '7%'}}>
                                        {/*<NHFormItem required={true} id={'khh'} initialValue={data['KHH']} form={form}  formItemLayout = {formItemLayout} label="开户行">
                                            <NHSelect sign={"zhxg_xs_khh"} onChange={(v) => { }} />
                                        </NHFormItem>*/}
                                        {/*<NHFormItem required={true} id={'yhzh'} initialValue={data['YHZH']} form={form} formItemLayout={formItemLayout} label="银行账户">
                                            <Input
                                                type="number"
                                                minLength={16}
                                                maxLength={19}
                                                placeholder="请正确填写银行账户"
                                                onBlur={(e) => {
                                                    const value = e.target.value;
                                                    const phoneRegex = /^[0-9]{16,19}$/; // 正则表达式用于匹配手机号码
                                                    if (!phoneRegex.test(value)) {
                                                        // 提示信息可以根据需求自定义
                                                        NHConfirm("请正确填写银行账户", () => {
                                                        }, "warn");
                                                        e.target.value =null
                                                    }
                                                }}
                                            />
                                        </NHFormItem>*/}
                                        <NHFormItem required={true} id={'sjhm'} initialValue={data['SJHM']} form={form} formItemLayout={formItemLayout} label="手机号码">
                                            <Input
                                                type="tel"
                                                minLength={11}
                                                maxLength={11}
                                                placeholder="请填写手机号码"
                                                onBlur={(e) => {
                                                    const value = e.target.value;
                                                    const phoneRegex = /^1[3-9]\d{9}$/; // 正则表达式用于匹配手机号码
                                                    if (!phoneRegex.test(value)) {
                                                        // 提示信息可以根据需求自定义
                                                        NHConfirm("手机号码格式错误，请正确填写", () => {
                                                        }, "warn");
                                                        e.target.value =null
                                                    }
                                                }}
                                            />
                                        </NHFormItem>
                                        {/*<NHFormItem required={true} id={'xn'} initialValue={data['XN']} form={form}  formItemLayout = {formItemLayout} label="学年">*/}
                                        {/*    <NHSelect sign={"zhxg_dqxn"} value={} />*/}
                                        {/*</NHFormItem>*/}
                                        <NHFormItem required={true} id={'jzdz'}  initialValue={null} form={form}  formItemLayout = {formItemLayout} label="居住地址">
                                            <NHCascader style={{width: 340}} sign={"zhxg_ssq"}
                                                        onChange={(value, selectedOptions) => this.onNHCascaderChange(value, selectedOptions)}
                                            />
                                        </NHFormItem>
                                        <NHFormItem required={true} id={'jzdxxdz'}  initialValue={data['JZDXXDZ']} form={form}  formItemLayout = {formItemLayout} label="居住地详细地址">
                                            <TextArea maxLength ={50} placeholder="请填写居住地详细地址" />
                                        </NHFormItem>
                                        <NHFormItem required={true} id={'sqzdly'}  initialValue={data['SQZDLY']} form={form}  formItemLayout = {formItemLayout} label="走读理由">
                                            <TextArea maxLength ={50} placeholder="请填写走读理由" />
                                        </NHFormItem>
                                        <NHFormItem required={true} id={'zdsj'} initialValue={data['ZDSJ']} form={form}  formItemLayout = {formItemLayout} label="走读时间">
                                            <RangePicker
                                                // disabledDate={this.disabledDate}
                                                format={dateFormat}
                                                style={{ width: '150%' }}
                                                onChange={(value) => { this.handleDateChange(value,0) }}
                                            />
                                        </NHFormItem>
                                        {/*<NHFormItem required={true} id={'sftf'} initialValue={data['sftf']} form={form}  formItemLayout = {formItemLayout} label="是否需要退费">
                                            <Radio.Group style={{display:"flex",margin:"10px"}}>
                                                <Radio value={'1'}>是</Radio>
                                                <Radio value={'0'}>否</Radio>
                                            </Radio.Group>
                                        </NHFormItem>*/}

                                        <NHFormItem required={true} id={'jzxm'} initialValue={data['JZXM']} form={form}  formItemLayout = {formItemLayout} label="家长姓名">
                                            <Input maxLength ={6} placeholder="请填写家长姓名" />
                                        </NHFormItem>
                                        <NHFormItem required={true} id={'jzdh'} initialValue={data['JZDH']} form={form} formItemLayout={formItemLayout} label="家长电话">
                                            <Input
                                                type="tel"
                                                minLength={11}
                                                maxLength={11}
                                                placeholder="请填写家长手机号码"
                                                onBlur={(e) => {
                                                    const value = e.target.value;
                                                    const phoneRegex = /^1[3-9]\d{9}$/; // 正则表达式用于匹配手机号码
                                                    if (!phoneRegex.test(value)) {
                                                        // 提示信息可以根据需求自定义
                                                        NHConfirm("家长手机号码格式错误，请正确填写", () => {
                                                        }, "warn");
                                                        e.target.value =null
                                                    }
                                                }}
                                            />
                                        </NHFormItem>

                                        <NHFormItem required={true} id={'sfzgh'} initialValue={data['SFZGH']} form={form}  formItemLayout = {formItemLayout} label="本人身份证国徽图片">

                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'上传本人身份证件国徽面'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />
                                        </NHFormItem>

                                        <NHFormItem required={true} id={'sfzrx'} initialValue={data['SFZRX']} form={form}  formItemLayout = {formItemLayout} label="本人身份证件人像面">

                                            <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'上传本人身份证件人像面'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                        </NHFormItem>

                                        <NHFormItem required={true} id={'jzsfzgh'} initialValue={data['JZSFZGH']} form={form}  formItemLayout = {formItemLayout} label="家长身份证国徽图片">
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'家长身份证国徽图片'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />

                                        </NHFormItem>

                                        <NHFormItem required={true} id={'jzsfzrx'} initialValue={data['JZSFZRX']} form={form}  formItemLayout = {formItemLayout} label="家长身份证件人像面">
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'家长身份证件人像面'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />

                                        </NHFormItem>

                                        <NHFormItem required={true} id={'hkbhz'} initialValue={data['HKBHZ']} form={form}  formItemLayout = {formItemLayout} label="户口本户主页">

                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'户主户口页'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />
                                        </NHFormItem>
                                        <NHFormItem required={true} id={'hkbxs'} initialValue={data['HKBXS']} form={form}  formItemLayout = {formItemLayout} label="本人户口页">

                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'本人户口页'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />
                                        </NHFormItem>

                                        <NHFormItem required={true} id={'fjid'}  initialValue={data['FJID']} form={form}
                                                    formItemLayout = {formItemLayout}
                                                    label={<span>安全协议第一页(<span style={{color: '#397ef0'}}onClick={() => this.handleDownload(mbid)}>模板</span>)</span>}>
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'安全协议第一页'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />
                                        </NHFormItem>

                                        <NHFormItem required={true} id={'aqxytwo'} initialValue={data['AQXYTWO']}
                                                    form={form}
                                                    formItemLayout={formItemLayout}
                                                    label="安全协议第二页">
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'安全协议第二页'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />

                                        </NHFormItem>


                                        <NHFormItem required={true} id={'zfxy'} initialValue={data['ZFXY']} form={form}
                                                    formItemLayout={formItemLayout}
                                                    label="租房协议（本地户口提供房产证）">
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'租房协议（本地户口提供房产证）'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />

                                        </NHFormItem>

                                    </div>}
                                </div>
                                    <div className="text-center mt-50">
                                        {shzt === 3 &&
                                            <Button disabled={true} style={{marginRight: '10px'}}>
                                                审核不通过
                                            </Button>}
                                        <Button type="primary" htmlType="submit" onClick={this.handleOk}
                                                loading={this.state.saveLoading}>
                                            {shzt === 3 ? '再次提交' : '提交'}
                                        </Button>
                                    <NextButton nextUrl={this.state.nextUrl}  search={this.state.search}/>
                                </div>
                            </Form>
                            :<View shzt={shzt} nextUrl={this.state.nextUrl} search={this.state.search} getDataView={()=>this.getDataView("edit")}  data={this.state.data} />}
                        </div>
                    </Flex.Item>
                </Flex>
                    <Spin style={{ position:'absolute',top:'300px',left:'60%'}} spinning={this.state.loading}/> </div>:<CommonTip hjmc = {hjmc}  key={mkbz} mkbz={mkbz} nonOperationalData={this.state.nonOperationalData}/>}
            </div>

        );
    }
}
